<template>
    <modal name="password-update-modal" class="password-update-modal "
           :width="600"
           :height="'auto'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="modal_title">비밀번호 변경</div>
        <div class="pl30 pr30 pb30">
            <div class="modal_info">
                비밀번호 조건 <br>
                8~16자 이내
            </div>
            <password-update-component :afterFunc="closeModal" :memberKey="memberKey"></password-update-component>
            <div class="btn_box text-center mt20">
                <el-button class="reg_btn_out" @click="save()">변경</el-button>
                <el-button class="com_btn" @click="closeModal()">닫기</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import PasswordUpdateComponent from "@/components/member/PasswordUpdateComponent";
import EventBus from "../../utils/event-bus";

export default {
    name: "PasswordUpdateModal",
    mixins: [],
    components: {PasswordUpdateComponent},
    inject: {},
    provide() {
        return {}
    },
    props: {
        memberKey: {default: 0},
    },
    data() {
        return {}
    },
    created() {
    },
    mounted() {


    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen(event) {
            this.memberKey = event.params.memberKey;
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
        },
        save() {
            EventBus.$emit('runPasswordUpdate')
        },
        closeModal() {
            this.$modal.hide('password-update-modal')
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
